import { ref, readonly } from 'vue'

const memoryState = ref(false)
const setMemoryState = state => {
  memoryState.value = state
}

export const useMemoryState = () => {
  return {
    memoryState: readonly(memoryState),
    setMemoryState
  }
}
